<ng-container *ngIf="mirror; else default">
  <ta-selected-options-list
    [disabled]="disabled"
    [disallowedOptions]="disallowedOptions"
    [disableDisallowedOptions]="disableDisallowedOptions"
    [searchThreshold]="searchThreshold"
    taTag="selected-list"
  ></ta-selected-options-list>
  <div #controls>
    <div
      (taInteract)="unselectAll()"
      [disabled]="disabled"
      taTag="unselect-all"
      class="button button--icon button--square"
      [ngClass]="{'button--disabled': disabled}"
    >
      <ta-icon icon="angle-double-right"></ta-icon>
    </div>
    <div
      (taInteract)="transferToAvailable()"
      [disabled]="disabled"
      taTag="unselect"
      class="button button--icon button--square"
      [ngClass]="{'button--disabled': disabled}"
    >
      <ta-icon icon="angle-right"></ta-icon>
    </div>
    <div
      (taInteract)="transferToSelected()"
      [disabled]="disabled"
      taTag="select"
      class="button button--icon button--square"
      [ngClass]="{'button--disabled': disabled}"
    >
      <ta-icon icon="angle-left"></ta-icon>
    </div>
    <div
      (taInteract)="selectAll()"
      [disabled]="disabled"
      taTag="select-all"
      class="button button--icon button--square"
      [ngClass]="{'button--disabled': disabled}"
    >
      <ta-icon icon="angle-double-left"></ta-icon>
    </div>
  </div>
  <ta-available-options-list
    [disabled]="disabled"
    [disallowedOptions]="disallowedOptions"
    [searchThreshold]="searchThreshold"
    taTag="available-list"
  ></ta-available-options-list>
</ng-container>
<ng-template #default>
  <ta-available-options-list
    [disabled]="disabled"
    [disallowedOptions]="disallowedOptions"
    taTag="available-list"
  ></ta-available-options-list>
  <div #controls>
    <div
      (taInteract)="selectAll()"
      [disabled]="disabled"
      taTag="select-all"
      class="button button--icon button--square"
      [ngClass]="{'button--disabled': disabled}"
    >
      <ta-icon icon="angle-double-right"></ta-icon>
    </div>
    <div
      (taInteract)="transferToSelected()"
      [disabled]="disabled"
      taTag="select"
      class="button button--icon button--square"
      [ngClass]="{'button--disabled': disabled}"
    >
      <ta-icon icon="angle-right"></ta-icon>
    </div>
    <div
      (taInteract)="transferToAvailable()"
      [disabled]="disabled"
      taTag="unselect"
      class="button button--icon button--square"
      [ngClass]="{'button--disabled': disabled}"
    >
      <ta-icon icon="angle-left"></ta-icon>
    </div>
    <div
      (taInteract)="unselectAll()"
      [disabled]="disabled"
      taTag="unselect-all"
      class="button button--icon button--square"
      [ngClass]="{'button--disabled': disabled}"
    >
      <ta-icon icon="angle-double-left"></ta-icon>
    </div>
  </div>
  <ta-selected-options-list
    [disabled]="disabled"
    [disallowedOptions]="disallowedOptions"
    [disableDisallowedOptions]="disableDisallowedOptions"
    [searchThreshold]="searchThreshold"
    taTag="selected-list"
  ></ta-selected-options-list>
</ng-template>
